import { Theme, useTheme } from "@emotion/react";
import { SelectChangeEvent, FormControl, InputLabel, Select, OutlinedInput, Box, Chip, MenuItem } from "@mui/material";
import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name: string, selectedValues: readonly any[], theme: Theme) {
    return {
      fontWeight: selectedValues?.some(s=> s.name == name)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
  }


const MultiSelect = ({label, values, selectedValues, setSelectedValues})=>{
        const theme = useTheme();
      
        const handleChange = (event) => {
          const {
            target: { value },
          } = event;
          setSelectedValues(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
          );
        };

        const deleteItem = (value) => {

          let index = selectedValues?.findIndex(s=>s.id == value.id);
          if(index == -1) return;
          selectedValues.splice(index, 1);
          setSelectedValues(selectedValues);
    
      }
        return (
          <div>
            <FormControl sx={{ mt: 2, ml:1, minWidth: 120 }}>
              <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
              <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={selectedValues || []}
                onChange={handleChange}
                input={<OutlinedInput id="select-multiple-chip" label={label} />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: 0.5, overflow: 'hidden', maxHeight: 32 }}>
                    {selected.map((value) => (
                      <Chip key={value.id} label={value.name} size="small" deleteIcon={
                        <CancelIcon
                          onMouseDown={(event) => event.stopPropagation()}
                        />
                      } onDelete={(e) => { deleteItem(value)
                      }}  />
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {values.map((v) => (
                  <MenuItem
                    key={v.name}
                    value={v}
                    style={getStyles(v.name, selectedValues, theme)}
                  >
                    {v.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );
}
export default MultiSelect;